//接口基准路径
const api_url = 'https://food-yun.xiaocx.org/Admin';
// const api_url = 'http://food-yun.xiaocx.my/Admin';

// 七牛云域名(华东)
const upload_url = 'https://up-z0.qiniup.com/';
const img_url = "http://xiaocx-cdn.xiaocx.org/";


export default {
    api_url,
    upload_url,
    img_url
}


// WEBPACK FOOTER //
// ./src/util/common.js